export const PREPLAY_EVENT_PAGE_ID = 'preplay-event';
export const PREPLAY_EVENT_PAGE_SELECTOR = '.preplay-event-selections';
export const PREPLAY_BET_BUTTON_SELECTOR = '.preplay-bet-button';
export const PREPLAY_PRICE_UPDATE_EVENT_NAME = `${PREPLAY_EVENT_PAGE_ID}:price-update`;
export const PREPLAY_EVENT_OFF_EVENT_NAME = `${PREPLAY_EVENT_PAGE_ID}:event-off`;
export const PREPLAY_MARKET_CHANGE_EVENT_NAME = 'preplay:market-tab:change';
export const PREPLAY_WS_HANDLER_COMPONENT_NAME = 'PreplaySportPage';
export const PREPLAY_READY = 'preplay:ready';
